import React from 'react';
import { Phone, Heart } from 'lucide-react';

const StepEmergencyMedical = ({ formData, onChange }) => (
  <div className="form-step">
    <h3><Phone size={20} /> Emergency Contact</h3>

    <div className="form-row">
      <div className="form-group">
        <label>Contact Name *</label>
        <input type="text" name="emergency_contact_name" value={formData.emergency_contact_name} onChange={onChange} placeholder="Emergency contact name" />
      </div>
      <div className="form-group">
        <label>Relationship *</label>
        <select name="emergency_contact_relation" value={formData.emergency_contact_relation} onChange={onChange}>
          <option value="">Select...</option>
          <option value="mother">Mother</option>
          <option value="father">Father</option>
          <option value="grandparent">Grandparent</option>
          <option value="aunt_uncle">Aunt/Uncle</option>
          <option value="sibling">Sibling</option>
          <option value="other">Other</option>
        </select>
      </div>
    </div>

    <div className="form-group">
      <label>Emergency Phone *</label>
      <input type="tel" name="emergency_contact_phone" value={formData.emergency_contact_phone} onChange={onChange} placeholder="(410) 555-0123" />
    </div>

    <h3 style={{ marginTop: '30px' }}><Heart size={20} /> Medical Information</h3>

    <div className="form-group">
      <label>Medical Conditions (if any)</label>
      <textarea name="medical_conditions" value={formData.medical_conditions} onChange={onChange} placeholder="List any medical conditions coaches should be aware of..." rows={3} />
    </div>

    <div className="form-row">
      <div className="form-group">
        <label>Allergies</label>
        <input type="text" name="allergies" value={formData.allergies} onChange={onChange} placeholder="Food, medication, or other allergies" />
      </div>
      <div className="form-group">
        <label>Current Medications</label>
        <input type="text" name="medications" value={formData.medications} onChange={onChange} placeholder="List any medications" />
      </div>
    </div>

    <div className="form-row">
      <div className="form-group">
        <label>Insurance Provider</label>
        <input type="text" name="insurance_provider" value={formData.insurance_provider} onChange={onChange} placeholder="Insurance company name" />
      </div>
      <div className="form-group">
        <label>Policy Number</label>
        <input type="text" name="insurance_policy_number" value={formData.insurance_policy_number} onChange={onChange} placeholder="Policy/Member ID" />
      </div>
    </div>
  </div>
);

export default StepEmergencyMedical;
